<template>
  <div>
    <div class="flex flex-wrap items-center">
      <div class="flex-grow">
        <div class="flex-grow">
          <vs-button v-if="userdata.privilegeNumber == 4" color="primary" type="gradient" class="mb-4 md:mb-0" @click="add">Add New Data</vs-button>
        </div>
      </div>
      <vs-dropdown vs-trigger-click class="cursor-pointer mr-2">
        <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
          <span class="mr-2">{{ page * per_page - (per_page - 1) }} - {{ row_total - page * per_page > 0 ? page * per_page : row_total }} of {{ row_total }}</span>
          <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
        </div>
        <vs-dropdown-menu>
          <vs-dropdown-item @click="updatePerPage(10)">
            <span>10</span>
          </vs-dropdown-item>
          <vs-dropdown-item @click="updatePerPage(25)">
            <span>25</span>
          </vs-dropdown-item>
          <vs-dropdown-item @click="updatePerPage(50)">
            <span>50</span>
          </vs-dropdown-item>
          <vs-dropdown-item @click="updatePerPage(100)">
            <span>100</span>
          </vs-dropdown-item>
        </vs-dropdown-menu>
      </vs-dropdown>
      <vs-input class="mr-0 sm:w-auto w-full sm:order-normal order-3 sm:mt-0 mt-4" v-model="keyword" @keyup="search" placeholder="Search..." />
    </div>

    <div class="table-container">
      <table class="table">
        <thead>
          <tr>
            <th>No</th>
            <th>IMEI</th>
            <th>Device Name</th>
            <th>Service</th>
            <th>Last Service</th>
            <th>Last Odometer</th>
            <th>Next Service</th>
            <th>Next Odometer</th>
            <th>Note</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody v-if="loading">
          <tr>
            <td colspan="10" class="text-center">Loading....</td>
          </tr>
        </tbody>
        <tbody v-else-if="data.length > 0">
          <tr v-for='(item, index) in data' :key='index'>
            <td>{{ ((page-1)*per_page) + (index+1) }}</td>
            <td>{{ item.imei }}</td>
            <td>{{ item.gps_data ? item.gps_data.device_name : '' }}</td>
            <td>{{ item.service ? item.service.name : '' }}</td>
            <td>{{ item.last_time }}</td>
            <td>{{ item.last_odo }} Km</td>
            <td>{{ item.next_time }}</td>
            <td>{{ item.next_odo }} Km</td>
            <td>{{ item.note }}</td>
            <td style="width: 90px">
              <div class="flex">
                <vx-tooltip text="Edit Assignmnent" position="top">
                  <vs-button :id="`editBtn${item.id}`" type="border" size="small" icon-pack="feather" icon="icon-edit" color="success" class="mr-2 vs-con-loading__container" @click="edit(item.id)"></vs-button>
                </vx-tooltip>
                <vx-tooltip text="Delete" position="top">
                  <vs-button type="border" size="small" icon-pack="feather" icon="icon-trash" color="danger" @click="del(item.id)"></vs-button>
                </vx-tooltip>
              </div>
            </td>
          </tr>
        </tbody>
        <tbody v-else>
          <tr>
            <td colspan="10" class="text-center">No Data Available</td>
          </tr>
        </tbody>
      </table>

      <vs-pagination :total="n_page" v-model="page"></vs-pagination>


      <vs-popup classContent="popup-example" :title="popupTitle" :active.sync="showPopup">
        <template>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-2/2 w-full">
              <label class="text-sm opacity-75">Service</label>
              <v-select :options="serviceList" :dir="$vs.rtl ? 'rtl' : 'ltr'" v-model="input.service" class="mb-2 md:mb-0" />
            </div>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-2/2 w-full">
              <label class="text-sm opacity-75">Device</label>
              <v-select :disabled="action == 'edit'" :options="deviceList" :dir="$vs.rtl ? 'rtl' : 'ltr'" v-model="input.imei" @search="searchDevice" class="mb-2 md:mb-0" />
            </div>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/2 w-full">
              <label class="text-sm opacity-75">Last Odometer (Km)</label>
                <vs-input type="number" class="w-full" v-model="input.last_odo"/>
            </div>
            <div class="vx-col sm:w-1/2 w-full">
              <label class="text-sm opacity-75">Last Service</label>
              <template>
                <flat-pickr label="STNK" class="w-full" v-model="input.last_time" />
              </template>
            </div>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/2 w-full">
              <label class="text-sm opacity-75">Next Odometer (Km)</label>
                <vs-input disabled type="text" class="w-full" v-model="input.next_odo"/>
            </div>
            <div class="vx-col sm:w-1/2 w-full">
              <label class="text-sm opacity-75">Next Service</label>
              <template>
                <flat-pickr disabled label="STNK" class="w-full" v-model="input.next_time" />
              </template>
            </div>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col w-full">
              <vs-textarea label="Notes" class="w-full" rows="3" v-model="input.note" />
            </div>
          </div>
          <div class="vx-row">
            <div class="vx-col w-full ml-auto">
              <vs-button :disabled="loading" id="submitBtn"  class="mr-3 mb-2 vs-con-loading__container" @click="submit">Submit</vs-button>
              <vs-button v-show="action === 'add'" color="warning" type="border" @click="reset" class="mb-2">Reset</vs-button>
            </div>
          </div>

        </template>
      </vs-popup>

    </div>
  </div>
</template>

<script>
import vSelect from 'vue-select'

import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';

export default {
  name: 'MaximumParking',
  components: {
    vSelect, flatPickr
  },
  data () {
    return {
      data: [],
      actor: '',
      token: '',
      showPopup: false,
      popupTitle: '',
      action: '',

      loading: false,
      tempId: 0,

      input: {
        service: '',
        imei: '',
        last_time: '',
        last_odo: '',
        next_odo: '',
        next_time: '',
        note: '',
      },

      deviceList: [],
      serviceList: [],

      page: 1,
      per_page: 10,
      row_total: 0,
      keyword: '',

      timer: null,
      notify: 'Server Error',
    }
  },

  watch: {
    page() {
      this.initTable()
    },

    per_page() {
      if(this.page != 1) this.page = 1
      else this.initTable()
    },

    last_odo(value) {
      if(value != '' && this.input.service != '') {
        this.input.next_odo = parseInt(value) + parseInt(this.input.service.odo_freq)
      } else {
        this.input.next_odo = ''
      }
    },

    last_time(value) {
      if(value != '' && this.input.service != '') {
        let time = new Date(value).getTime()
        let next_time_second = time + (parseInt(this.input.service.time_freq) * 86400000 )
        this.input.next_time = next_time_second
      } else {
        this.input.next_time = ''
      }
    },

    service(value) {
      if(value != '') {
        if(this.input.last_odo != '')  {
          this.input.next_odo = parseInt(this.input.last_odo) + parseInt(this.input.service.odo_freq)
        } else {
          this.input.next_odo = ''
        }

        if(this.input.last_time != '') {
          let time = new Date(this.input.last_time).getTime()
          let next_time_second = time + (parseInt(this.input.service.time_freq) * 86400000 )
          this.input.next_time = next_time_second
        } else {
          this.input.next_time = ''
        }
      }
    }
  },

  computed: {
    n_page() {
      return Math.ceil(this.row_total/this.per_page)
    },

    userdata() {
      return this.$store.state.AppActiveUser
    },

    last_odo() {
      return this.input.last_odo
    },

    last_time() {
      return this.input.last_time
    },

    service() {
      return this.input.service
    }
  },

  mounted () {
  },

  created () {
    this.token = localStorage.getItem('userInfo') !== null ? JSON.parse(localStorage.getItem('userInfo')).token : ''

    this.initTable()
    this.selectService()
  },

  methods: {
    search() {
      if (this.timer) {
        clearTimeout(this.timer);
        this.timer = null;
      }
      this.timer = setTimeout(() => {
        this.page = 1
        this.initTable()
      }, 800);
    },

    updatePerPage(n) {
      this.per_page = n
      this.initTable()
    },

    reset() {
      Object.keys(this.input).map(item => {
        this.input[item] = ''
      })
    },

    selectService() {
      this.$http.get(`${this.$api.endpoint}/service/select`, {
        headers: {
          Authorization: `Bearer ${this.token}`
        }
      }).then(res => {
        this.serviceList = res.data.message.data
      }).catch(error => {
        this.$gf.httpErrorHandler(error)
      })
    },

    searchDevice(keyword) {
      if(keyword.length >= 3) {
        this.$http.get(`${this.$api.endpoint}/tracking/search?keyword=${keyword}&type=vehicle`, {
          headers: {
            Authorization: `Bearer ${this.token}`
          }
        }).then(res => {
          this.deviceList = res.data.message.data
        }).catch(error => {
          this.$gf.httpErrorHandler(error)
        })
      }else{
        this.deviceList = []
      }
    },

    initTable() {
      this.loading = true
      this.$http.get(`${this.$api.endpoint}/service_assignment/datatable?page=${this.page}&per_page=${this.per_page}&search=${this.keyword}`, {
        headers: {
            Authorization: `Bearer ${this.token}`
        }
      }).then(res => {
        this.row_total = res.data.message.total
        this.data = res.data.message.data
        this.loading = false
      }).catch(error => {
        this.$gf.httpErrorHandler(error)
      })
    },

    add() {
      this.reset()
      this.action = 'add'
      this.popupTitle = 'Add Service'
      this.showPopup = true
    },

    edit(id) {
      this.tempId = id
      this.action = 'edit'
      this.popupTitle = 'Edit Service Assignment'

      this.$vs.loading({
        background: 'success',
        color: '#fff',
        container: "#editBtn" + id,
        scale: 0.45
      })

      this.$http.get(`${this.$api.endpoint}/service_assignment/detail/${id}`, {
        headers: {
            Authorization: `Bearer ${this.token}`
        }
      }).then(res => {
        this.$vs.loading.close(`#editBtn${id} > .con-vs-loading`)

        const data = res.data.message.data

        this.input.imei = {
          value: data.imei,
          label: `${data.gps_data.device_name} (device name)`
        }

        this.input.service = this.serviceList.find(item => {
          return item.value === data.service_id
        })

        this.input.note = data.note
        this.input.last_time = data.last_time
        this.input.last_odo = data.last_odo
        // this.input.next_odo = data.next_odo
        // this.input.next_time = data.next_time

        this.showPopup = true
      })
    },

    submit() {
      this.loading = true
      this.$vs.loading({
        background: 'primary',
        color: '#fff',
        container: "#submitBtn",
        scale: 0.45
      })

      let url = this.action === 'add' ? `${this.$api.endpoint}/service_assignment/add` : `${this.$api.endpoint}/service_assignment/update/${this.tempId}`
      // console.log(this.input.imei)
      this.$http.post(url, {
        imei: this.input.imei ? this.input.imei.value : '',
        service_id: this.input.service ? this.input.service.value : '',
        last_odo: this.input.last_odo,
        last_time: this.input.last_time,
        next_odo: this.input.next_odo,
        next_time: this.input.next_time,
        note: this.input.note
      },
      {
        headers:{
          Authorization: `Bearer ${this.token}`
        }
      }).then(res => {
        this.$vs.loading.close("#submitBtn > .con-vs-loading")
        this.notify = res.data.message.split('_').join(' ')

        this.loading = false
        this.showPopup = false
        this.initTable()
        this.reset()

        this.$vs.notify({
          title: 'Thank You',
          text: this.notify,
          color: 'success',
          position: 'top-right'
        })
      }).catch(error => {
        this.loading = false
        this.$vs.loading.close("#submitBtn > .con-vs-loading")
        this.$gf.httpErrorHandler(error)
      })
    },

    del(id) {
      this.tempId = id
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: `Delete Service`,
        text: 'Are you sure want to Delete this Service Schedule ?',
        accept: this.confirmDelete
      })
    },

    confirmDelete() {
      this.$http.post(`${this.$api.endpoint}/service_assignment/delete/${this.tempId}`, {}, {
        headers: {
          Authorization: `Bearer ${this.token}`
        }
      }).then(res => {
        this.notify = res.data.message.split('_').join(' ')
        this.initTable()

        this.$vs.notify({
          title: 'Thank You',
          text: this.notify,
          color: 'success',
          position: 'top-right'
        })
      }).catch(error => {
        this.$gf.httpErrorHandler(error)
      })
    },
  }
}
</script>
